module.exports = __webpack_public_path__ + "img/sass.02d69653.svg";